export default "__VITE_ASSET__QCamRG_J__"